import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, fmtDate } from "../lib/api";
import StatusBadge from "../components/StatusBadge";
import { Plus, FileText } from "lucide-react";

export default function Forms() {
  const navigate = useNavigate();
  const [forms, setForms] = useState([]);
  const [projects, setProjects] = useState([]);
  const [filterProject, setFilterProject] = useState("all");

  useEffect(() => {
    Promise.all([api.get("/forms"), api.get("/projects")]).then(([f, p]) => { setForms(f.data); setProjects(p.data); });
  }, []);

  const filtered = forms.filter((f) => filterProject === "all" || f.project_id === filterProject);

  return (
    <div className="space-y-6">
      <div className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <div className="text-[11px] uppercase tracking-[0.2em] text-btp-terra font-semibold mb-2">Production documentaire</div>
          <h1 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight">Formulaires & Livrables</h1>
          <p className="text-sm text-slate-500 mt-1">Éditeur dynamique type Notion — génération Word automatique</p>
        </div>
        <select value={filterProject} onChange={(e) => setFilterProject(e.target.value)} className="h-10 px-3 border border-slate-300 rounded-md text-sm bg-white" data-testid="form-filter-project">
          <option value="all">Tous les projets</option>
          {projects.map((p) => <option key={p.id} value={p.id}>{p.code} — {p.name}</option>)}
        </select>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {filtered.map((f) => {
          const project = projects.find((p) => p.id === f.project_id);
          return (
            <button key={f.id} onClick={() => navigate(`/forms/${f.id}`)}
              className="text-left bg-white border border-slate-200 rounded-md p-5 hover:border-btp-navy hover:shadow-md transition-all"
              data-testid={`form-card-${f.id}`}>
              <div className="flex justify-between items-start mb-3">
                <div className="font-mono text-[10px] uppercase tracking-wider px-2 py-0.5 bg-slate-100 text-slate-700 rounded">{f.doc_type}</div>
                <StatusBadge status={f.status} />
              </div>
              <h3 className="font-heading text-base font-bold leading-snug mb-1">{f.name}</h3>
              <div className="text-xs text-slate-500">{project?.code} · {project?.name}</div>
              <div className="mt-3 pt-3 border-t border-slate-100 flex justify-between items-center text-xs text-slate-500">
                <span>{f.sections?.length || 0} section(s)</span>
                <span className="font-mono">{fmtDate(f.updated_at)}</span>
              </div>
            </button>
          );
        })}
        {filtered.length === 0 && (
          <div className="md:col-span-2 xl:col-span-3 bg-white border border-dashed border-slate-300 rounded-md p-12 text-center">
            <FileText className="w-10 h-10 mx-auto text-slate-300 mb-2" />
            <p className="text-sm text-slate-500">Aucun formulaire — créez-en depuis l'onglet "Livrables" d'un projet.</p>
          </div>
        )}
      </div>
    </div>
  );
}
